var moduleName = "services.message";

const $inject = [];

/**
 * Handle retrieval of all Messages for current user
 */
class MessageService {
  /**
   * Init
   */
  constructor() {
    this.messages = [];
  }

  /**
   * Get the relevant messages
   * @returns {Array}
   */
  getAll() {
    return this.messages;
  }

  /**
   * add notification to service
   * @param {String} type
   * @param {String|Array} messages
   * @returns void
   */
  add(type, ...messages) {
    if (type === "danger" && messages.length === 0) {
      messages = ["An error occurred."];
    }

    for (let linksKey in messages) {
      if (!Array.isArray(messages[linksKey])) {
        messages[linksKey] = [messages[linksKey]];
      }
    }

    this.messages.push({
      type,
      messages,
    });
  }

  /**
   * Removes all notifications
   *
   * @returns void
   */
  clearAll() {
    this.messages.splice(0, this.messages.length);
  }

  /**
   * Remove notification
   * @param index
   */
  close(index) {
    this.messages.splice(index, 1);
  }
}

/**
 * Dependencies
 */
MessageService.$inject = $inject;

/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
  .service("MessageService", MessageService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/message.service.js
 **/